module.exports = __webpack_public_path__ + "static/img/bottom1.3c9219ae.jpg";